import React from "react";
import styles from "./CardWrapper.module.scss";
import classNames from "classnames";

const CardWrapper = ({ children, className }) => {
	return (
		<>
			<div className={classNames(styles.card, className)}>{children}</div>
		</>
	);
};

export default CardWrapper;
